import React from "react";
import Page from "components/base/Page";
import Button from "components/base/Button";
import { useQuery } from "@apollo/client";
import { FETCH_LOGOS } from "./graphql";
import LogosGridView from "./LogosGridView";
import { FiPlus } from "react-icons/fi";
import { useModals } from "ModalProvider";
import LogoFormModal from "./LogoFormModal";

function LogosPage() {
  const modal = useModals();
  const { refetch } = useQuery(FETCH_LOGOS);

  const handleCreateLogo = () => {
    modal.present({
      maxWidth: "max-w-3xl",
      center: true,
      children: <LogoFormModal refetch={refetch} hide={modal.hide} />,
    });
  };

  return (
    <Page
      title="Logos"
      rightButtons={
        <Button onClick={handleCreateLogo}>
          <span className="flex items-center">
            <FiPlus className="mr-2" />
            Create Logo
          </span>
        </Button>
      }
    >
      <div>
        <div className="m-6">
          <div className="opacity-70 space-y-2">
            <p>
              Click the "+ Create Logo" button on the top right to upload a new
              logo.
            </p>
          </div>
        </div>

        <LogosGridView />
      </div>
    </Page>
  );
}

export default LogosPage;
